import { ROUTE_CONFIG } from "@/routes/config";

import { AccountTabs } from "./accountTabs";

/**
 * Where "notification settings" lives: the NOTIFICATIONS tab of the account page. Outgoing e-mails
 * build the same link on the API side (`apps/api/src/mail/app-links.ts`) — keep the two in step.
 */
export const NOTIFICATION_SETTINGS_DEEP_LINK = `${ROUTE_CONFIG.ACCOUNT}?tab=${AccountTabs.NOTIFICATIONS}`;

/**
 * The path notification e-mails used before PREC-3789. It never existed as a route, and those mails
 * sit in inboxes indefinitely, so the app forwards it to {@link NOTIFICATION_SETTINGS_DEEP_LINK}
 * instead of showing "Page Not Found" (see `Private.tsx`).
 */
export const LEGACY_NOTIFICATION_SETTINGS_PATH = "/settings/notifications";
